/* eslint-disable react/jsx-props-no-spreading */
import CollectionTile from '../../molecules/collectionTile';
import SwiperWithArrows from '../../molecules/swiperWithArrows/SwiperWithArrows';
import { Heading } from '../../typography/heading/Heading';
import styles from './CollectionSection.module.scss';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import { Navigation } from 'swiper/modules';
import { SwiperSlide } from 'swiper/react';

const CollectionSection = (props) => {
  const { collections, title, backgroundColor } = props;
  const [activeIndex, setActiveIndex] = useState(0);

  const breakpoints = {
    320: {
      spaceBetween: 15,
      slidesPerView: 1.21,
      centeredSlides: false,
      initialSlide: 0,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
    },
    680: {
      spaceBetween: 30,
      slidesPerView: 2.2,
      centeredSlides: true,
      initialSlide: 1,
    },
    1120: {
      spaceBetween: 120,
      slidesPerView: 2.2,
      centeredSlides: true,
      initialSlide: 1,
    },
    2560: {
      spaceBetween: 150,
      centeredSlides: false,
      slidesPerView: 3,
      slidesOffsetBefore: collections.length > 3 ? 120 : 0,
      slidesOffsetAfter: collections.length > 3 ? 120 : 0,
    },
  };

  const swiperCollection = useMemo(() => {
    return collections ? (
      <div className={`${styles.collectionCarousel} ${collections.length <= 3 && styles.collectionCarouselAdditional}`}>
        <SwiperWithArrows
          modules={[Navigation]}
          breakpoints={breakpoints}
          onSlideChange={(e) => setActiveIndex(e.activeIndex)}
          slidesOffsetBefore={20}
          slidesOffsetAfter={20}
          onObserverUpdate={(swiper) => {
            const { isBeginning, isEnd } = swiper;
            if (isBeginning && isEnd) {
              swiper.enabled = false;
            } else {
              swiper.enabled = true;
            }
          }}
          observeParents={true}
          observer={true}
        >
          {collections.map((el, idx) => (
            <SwiperSlide key={idx}>
              <CollectionTile
                image={el.image}
                label={el.label ? el.label : ''}
                title={el.title ? el.title : ''}
                buttons={el.buttons && el.buttons}
                className={styles.collectionItem}
                defaultRatio={1.3}
                notActive={idx !== activeIndex}
              />
            </SwiperSlide>
          ))}
        </SwiperWithArrows>
      </div>
    ) : null;
  }, [activeIndex]);

  return (
    <div style={{ backgroundColor }} className={clsx(styles.collectionSectionContainer)}>
      {title && (
        <Heading as="h1" align="center">
          {title}
        </Heading>
      )}
      {swiperCollection}
    </div>
  );
};

CollectionSection.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        id: PropTypes.string,
        url: PropTypes.string,
        alt: PropTypes.string,
      }).isRequired,
      label: PropTypes.string,
      title: PropTypes.string,
      buttons: PropTypes.arrayOf(
        PropTypes.shape({
          variant: PropTypes.string,

          isOutlined: PropTypes.bool,
          isInverted: PropTypes.bool,
          as: PropTypes.string,
          text: PropTypes.string,
          size: PropTypes.string,
          href: PropTypes.string,
        }),
      ),
      isNotActive: PropTypes.bool,
      id: PropTypes.string,
    }),
  ),
  title: PropTypes.string,
  backgroundColor: PropTypes.string,
  spacing: PropTypes.string,
};

CollectionSection.defaultProps = {
  data: [],
  title: '',
  backgroundColor: '#571517',
  spacing: '',
};

export default CollectionSection;
